
import Vue from 'vue'
import { WrappedFormUtils } from 'ant-design-vue/types/form/form'

export default Vue.extend({
  metaInfo() {
    return {
      title: "Form | BOBU AFRICA",
      link: [
        { rel: "canonical", href: "/form" }
      ],
      meta: [
        { name: 'description', content: 'Form | BOBU AFRICA' },
        { property: "og:type", content: "website" },
        { property: "og:url", content: `https://bobuafrica.com/form` },
        { property: "og:title", content: "Form | BOBU AFRICA" },
        { property: "og:description", content: "Form | BOBU AFRICA" },

        { property: "twitter:card", content: "summary_large_image" },
        { property: "twitter:url", content: `https://bobuafrica.com/form` },
        { property: "twitter:title", content: "Form | BOBU AFRICA" },
        { property: "twitter:description", content: "Form | BOBU AFRICA" },

      ]
    }
  },
  data() {
    return {
      form: this.$form.createForm(this) as WrappedFormUtils,
      modal: false,
    }
  },
  methods: {
    onSubmit() {
      this.form.validateFieldsAndScroll((err: any, values: any) => {
        if (err) return
        this.$axios.post('/leads', values).then(() => {
          this.modal = true
        })
      })
    }
  }
})
